import { ApiBackClient } from '../../../services/apiADA';
import { saveInSessionStorage } from '../../../contexts/LocalStorage';

export function postRelatorio(modelo, params, sessionId, username, token) {
    return new Promise((resolve, reject) => {
        ApiBackClient.post("/relatorio", {modelo: modelo, paramEntrada: params, sessionid: sessionId},
            {
                headers: {
                    'Content-Type': 'application/json',
                    username: username,
                    Authorization: `Bearer ${token}`
                },
                baseURL: localStorage.getItem("base_url")
            })
            .then(res => {
                saveInSessionStorage("logid", res.headers.logid);
            })
            .catch(function (error) {
                consoleLogErros(error);
                if (error.response !== undefined && error.response.data !== undefined && error.response.data.error !== undefined) {
                    reject({ cod: 1, error: error.response.data.error });
                } else {
                    reject({ cod: 1, error: error });
                }
            });
    });
}

export function postGrupoCliente(find, username, token) {
    return new Promise((resolve, reject) => {
        ApiBackClient.post("/grupocliente", {find: find},
            {
                headers: {
                    'Content-Type': 'application/json',
                    username: username,
                    Authorization: `Bearer ${token}`
                },
                baseURL: localStorage.getItem("base_url")
            })
            .then(res => {
                saveInSessionStorage("logid", res.headers.logid);
                resolve(res.data instanceof Array ? res.data : [res.data])
            })
            .catch(function (error) {
                consoleLogErros(error);
                if (error.response !== undefined && error.response.data !== undefined && error.response.data.error !== undefined) {
                    reject({ cod: 1, error: error.response.data.error });
                } else {
                    reject({ cod: 1, error: error });
                }
            });
    });
}

function consoleLogErros(error) {
    console.log("error validação");
    console.log(error);
    if (error.response) {
        // Requisição feita e o servidor retornou um erro
        console.error(error.response.data);
        console.error(error.response.status);
        console.error(error.response.headers);
    } else if (error.request) {
        // A requisição foi feita, mas nenhuma resposta foi recebida
        console.error(error.request);
    } else {
        // Alguma coisa aconteceu nas configurações da requisição que gerou um erro
        console.error('Error', error.message);
    }
}